import mutations from './mutations';
import actions from './actions';

const defaultState = () => {
  return {};
};

const AiModels = {
  namespaced: true,
  state: defaultState,
  getters: {},
  mutations,
  actions,
};

export { AiModels, defaultState };
